import TimeLayer from "./TimeLayer";
import moment from "moment-timezone";

class NysmDailyLayer extends TimeLayer {
  constructor(opt_options) {
    const options = opt_options || {};
    const baseOptions = Object.assign({}, options);
    delete baseOptions.timezone;
    delete baseOptions.mapProjection;
    delete baseOptions.layerMakerCallback;
    super(baseOptions);

    this._mapProjection = options.mapProjection;
    this._layerMakerCallback = options.layerMakerCallback;
    this._timezone = options.timezone;

    this._loaded_times = new Set();

    this.load = this.load.bind(this);
  }

  load(timeManager) {
    const startTime = timeManager.start_date
      .clone()
      .tz(this._timezone)
      .startOf("day");
    const endTime = timeManager.end_date
      .clone()
      .tz(this._timezone)
      .startOf("day");
    let new_times = [];
    for (
      let time = startTime.clone();
      time.isSameOrBefore(endTime);
      time = time.clone().add(moment.duration(1, "day"))
    ) {
      new_times.push(time);
    }
    this._layer_times_received(new_times, timeManager);
  }

  _layer_times_received(new_times, timeManager) {
    // Filter times down to those that don't already have layers (or have layers pending), then
    // create layers for any new times.
    const times_loaded = this.getLayers()
      .getArray()
      .map((l) => l.get("time").valueOf());
    new_times
      .filter((t) => times_loaded.indexOf(t.valueOf()) === -1)
      .forEach((t) => {
        this._loaded_times.add(t.valueOf());
        let wait = null;
        if (this._layerMakerCallback) {
          wait = this._layerMakerCallback(t, this._mapProjection);
        } else {
          wait = new Promise((res) => res(null));
        }
        wait.then((new_layer) => {
          if (new_layer === null) {
            console.warn("No layer to add");
            return;
          }
          this.getLayers().push(new_layer);
        });
      });
  }

  track_realtime(isTracking, timeManager) {
    // Nothing to do. The timeManager will be sending out events every so
    // often, and that's good enough for my current use case.
  }
}

export default NysmDailyLayer;
